module.exports = __webpack_public_path__ + "static/media/sonic_0.a322bec6.png";